import { Controller } from '@hotwired/stimulus'

// Refreshes a lazy turbo-frame whose content is stale, typically because it was
// restored from Turbo's snapshot cache rather than fetched.
export default class extends Controller {
  initialize() {
    this.element.setAttribute('loading', 'lazy')
  }

  connect() {
    document.addEventListener('turbo:load', this.rehydrate)
  }

  disconnect() {
    document.removeEventListener('turbo:load', this.rehydrate)
  }

  // Turbo's reload() cancels the frame's in-flight request, and a lazy frame
  // that has not finished loading once will not start another — so reloading
  // mid-first-load leaves the placeholder on screen forever. `complete` is set
  // only after a frame has rendered a response.
  rehydrate = () => {
    if (this.element.hasAttribute('complete')) this.element.reload()
  }
}
